export default "__VITE_ASSET__CkqMTM7Y__"